import React from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAbout } from "../../../features/aboutSlice/aboutSlice";

const RegistrationCertificate = () => {
  const about = useSelector((state) => state.about);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchAbout());
  }, [dispatch]);
  return (
    <div className="max-w grid place-content-center">
      <div className="text-center">
        <h1 className="title-style !font-Yatra">दर्ता प्रमाण पत्र</h1>
        <div className="mt-4">
          <img src="./images/title-border.png" alt="" className="mx-auto" />
        </div>
      </div>
      <div className="mt-16 hidden md:block">

      {
  about.data?.filter((value)=>value.title==="दर्ता प्रमाण पत्र").map((item,index)=>{
    return(
      <div key={index} className="mx-auto max-w-4xl flex-row space-y-5 md:flex md:space-y-0">
      {/* text  */}


      {
        (index===0 || index===2)&&(
<div className="flex-1 px-5 text-center">
        <h2 className="sub-title-style">{item.title}</h2>
        <div className="bg-primary-blue mx-auto mt-1 h-1 w-[70%] rounded-full" />
        <p className="text-primary-blue font-Laila mt-3 text-sm lg:!text-xl text-justify">
      
      {
        item.description
      }
          {/* हजुरको व्यवसायको आवश्यकता अनुसारको सेवा पाउदिनकि भन्ने चिन्ता अब
          नलिनुहोस, कानुनी खातासंग आबद्द भयसंगै हजुरको एक दक्ष तथा अनुभबी
          Expert assign हुनुहुनेछ जसले हजुरलाई सम्पर्क गरि प्रतक्ष्य रुपमा
          हजुरको आवश्यकता/समस्या बुझी सोहि अनुरुप सल्लाह/सुझाब दिई चाहिने
          सेवाको बृस्तृत जानकारी समेत दिनुहुनेछ | हजुरले आफ्नो अनुकुलता
          अनुसार हाम्रो Expert संग प्रतक्ष्य कुरा गरी आफ्नो आवश्यकता पुरा 
          गर्न सक्नुहुने छ |*/}
        </p>
      </div>
        )
      }
        
      {/* image  */}
      <div className="mx-auto h-72 md:w-96  mb-3">
        <img
          // src="https://images.unsplash.com/photo-1646764578980-65dbce171e7b?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=881&q=80"
          src={item.image}
          alt=""
          className=" h-72 md:w-96 object-fill"
        />
      </div>
      {
        index===1 &&(
<div className="flex-1 px-5 pt-5 ]-black text-center">
        <h2 className="sub-title-style">{item.title}</h2>
        <div className="bg-primary-blue mx-auto mt-1 h-1 w-[70%] rounded-full" />
        <p className="text-primary-blue font-Laila mt-3 text-sm lg:!text-xl text-justify">
        {
        item.description
      }
         
          {/* हजुरको व्यवसायको आवश्यकता अनुसारको सेवा पाउदिनकि भन्ने चिन्ता अब
          नलिनुहोस, कानुनी खातासंग आबद्द भयसंगै हजुरको एक दक्ष तथा अनुभबी
          Expert assign हुनुहुनेछ जसले हजुरलाई सम्पर्क गरि प्रतक्ष्य रुपमा
          हजुरको आवश्यकता/समस्या बुझी सोहि अनुरुप सल्लाह/सुझाब दिई चाहिने
          सेवाको बृस्तृत जानकारी समेत दिनुहुनेछ | हजुरले आफ्नो अनुकुलता
          अनुसार हाम्रो Expert संग प्रतक्ष्य कुरा गरी आफ्नो आवश्यकता पुरा
          गर्न सक्नुहुने छ | */}
        </p>
      </div>
        )
      }
    </div>
      )
    })
  }
  
   
        {/* <div className="mx-auto mt-12 max-w-4xl flex-row-reverse space-y-5 md:flex md:space-y-0">
         
          <div className="flex-1 px-5 text-center">
            <h2 className="sub-title-style">दर्ता प्रमन पत्र</h2>
            <div className="bg-primary-blue mx-auto mt-1 h-1 w-[60%] rounded-full" />
            <p className="text-primary-blue font-Laila mt-3 text-sm lg:!text-xl">
              हजुरको व्यवसायको आवश्यकता अनुसारको सेवा पाउदिनकि भन्ने चिन्ता अब
              नलिनुहोस, कानुनी खातासंग आबद्द भयसंगै हजुरको एक दक्ष तथा अनुभबी
              Expert assign हुनुहुनेछ जसले हजुरलाई सम्पर्क गरि प्रतक्ष्य रुपमा
              हजुरको आवश्यकता/समस्या बुझी सोहि अनुरुप सल्लाह/सुझाब दिई चाहिने
              सेवाको बृस्तृत जानकारी समेत दिनुहुनेछ | हजुरले आफ्नो अनुकुलता
              अनुसार हाम्रो Expert संग प्रतक्ष्य कुरा गरी आफ्नो आवश्यकता पुरा
              गर्न सक्नुहुने छ |
            </p>
          </div>
         
          <div className="mx-auto h-72 md:w-96">
            <img
              src="https://images.unsplash.com/photo-1646764578980-65dbce171e7b?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=881&q=80"
              alt=""
              className="h-full w-full object-cover"
            />
          </div>
        </div> */}
      </div>

      <div className="md:hidden">
{
      about.data?.filter((value)=>value.title==="दर्ता प्रमाण पत्र").map((item,i)=>{

                return (
                  <div
                    className="mx-auto max-w-4xl flex-row items-center space-y-5 md:flex md:space-y-5"
                    key={i}
                  >
                    <>
                      <div className="flex-1 px-5 text-center">
                        <h2 className="sub-title-style">{item.title}</h2>
                        <div className="bg-primary-blue mx-auto mt-1 h-1 w-[70%] rounded-full" />
                        <p className="text-primary-blue font-Laila mt-3 text-justify text-sm lg:!text-xl">
                          {item.description}
                        </p>
                      
                      </div>
                      <div className="mx-auto h-72 md:w-96">
                        <img
                          src={item.image}
                          alt=""
                          className="h-full w-full rounded-tl-3xl rounded-br-3xl object-cover"
                        />
                      </div>
                    </>
                  </div>
                );
              })}

      </div>
    </div>
  );
};

export default RegistrationCertificate;
